<template>
  <b-container>
    <b-row>
      <b-col @paste="onPasteFront">
        <b-form-group label="Fronte" class="col-md-12">
          <b-icon id="front-picture-ico" v-if="!value.frontPicture && !value.frontPdf" icon="card-image" font-scale="8"></b-icon>
          <b-img id="front-picture-img" v-if="value.frontPicture" :src="value.frontPicture" fluid></b-img>
          <img id="front-picture-pdf" v-if="value.frontPdf" src="@/assets/pdf-file-icon.svg" width="20%" alt="Documento caricato"/>

          <b-form-file
            id="front-picture-name"
            placeholder=""
            v-model="frontPictureName"
            v-validate='{ required: true }'
            name="Immagine fronte documento"
            :state="stateValidation('Immagine fronte documento')"
            aria-describedby="input-front-picture-feedback"
            :file-name-formatter="formatFileNames"
            browse-text="Carica file"
            accept="image/*, application/pdf"
            :capture="true"
            v-on:change="frontPictureTaken">
          </b-form-file>

          <b-form-invalid-feedback id="input-front-picture-feedback">
            {{ veeErrors.first('Immagine fronte documento') }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col @paste="onPasteBack">
        <b-form-group label="Retro" class="col-md-12">
          <b-icon id="back-picture-ico" v-if="!value.backPicture && !value.backPdf" icon="card-image" font-scale="8"></b-icon>
          <b-img id="back-picture-img" v-if="value.backPicture" :src="value.backPicture" fluid></b-img>
          <img id="back-picture-pdf" v-if="value.backPdf" src="@/assets/pdf-file-icon.svg" width="20%" alt="Documento caricato"/>

          <b-form-file
            id="back-picture-name"
            placeholder=""
            v-model="backPictureName"
            v-validate="{ required: false }"
            name="Immagine retro documento"
            :state="stateValidation('Immagine retro documento')"
            aria-describedby="input-back-picture-feedback"
            :file-name-formatter="formatFileNames"
            browse-text="Carica file"
            accept="image/*, application/pdf"
            :capture="true"
            v-on:change="backPictureTaken">
          </b-form-file>

          <b-form-invalid-feedback id="input-back-picture-feedback">
            {{ veeErrors.first('Immagine retro documento') }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>

</template>

<script>

import '@/assets/pdf-file-icon.svg'

export default {
  name: "DocumentUpload",
  props: ['value'],
  inject: ['parentValidator'],
  created() {
    this.$validator = this.parentValidator
    this.$on('input', () => this.$forceUpdate())
  },
  data: () => ({
    frontPictureName: null,
    backPictureName: null,
    pdfName: null
  }),
  methods: {
    reset() {
      this.frontPictureName = null
      this.backPictureName = null
      this.pdfName = null
      this.$validator.reset()
    },
    onPasteFront(evt) {
      const item = Array.from(evt.clipboardData.items).find(x => /^image\//.test(x.type))
      const file = item.getAsFile()
      this.frontPictureName =  file
      this.readFile(file)
        .then(result => {
          this.value.frontPicture = result
          delete this.value.frontPdf
          this.$emit('input', this.value)
        })
    },
    onPasteBack(evt) {
      const item = Array.from(evt.clipboardData.items).find(x => /^image\//.test(x.type))
      const file = item.getAsFile()
      this.backPictureName =  file
      this.readFile(file)
        .then(result => {
          this.value.backPicture = result
          delete this.value.backPdf
          this.$emit('input', this.value)
        })
    },
    formatFileNames() {
      return ""
    },
    readFile(file) {
      return new Promise((resolve, reject) => {
        let fr = new FileReader();
        fr.onload = () => resolve(fr.result);
        fr.onerror = reject;
        fr.readAsDataURL(file);
      });
    },
    frontPictureTaken(event) {
      let file = event.target.files[0];
      this.readFile(file)
        .then(result => {
          if (file.type.startsWith('image')) {
            this.value.frontPicture = result
            delete this.value.frontPdf
          } else {
            this.value.frontPdf = result
            delete this.value.frontPicture
          }
          this.$emit('input', this.value)
        })
    },
    backPictureTaken(event) {
      let file = event.target.files[0];
      this.readFile(file)
        .then(result => {
          if (file.type.startsWith('image')) {
            this.value.backPicture = result
            delete this.value.backPdf
          } else {
            this.value.backPdf = result
            delete this.value.backPicture
          }
          this.$emit('input', this.value)
        })
    },
    stateValidation(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref)
      } else {
        return null
      }
    },
  }
}
</script>

<style>
#back-picture-img, #back-picture-img, #front-picture-pdf, #back-picture-pdf {
  margin-bottom: 1em;
}

#front-picture-img, #front-picture-img {
  margin-bottom: 1em;
}
</style>
